/**
 * The two pipeline views (F2).
 *
 * Separate from `ViewToggle.tsx` so that file exports only a component — a
 * module mixing components and constants defeats fast refresh.
 */
import type { IconName } from '../../../components/ui/icon-names';

export const VIEWS = ['table', 'board'] as const;

export type PipelineView = (typeof VIEWS)[number];

/** Icon per view, from the design system's 36-icon sprite. */
export const VIEW_ICON: Record<PipelineView, IconName> = {
  table: 'checklist',
  board: 'grid',
};
